import { UseFormInput, UseFormReturnType, useForm } from '@mantine/form';

import { useFormy } from './useFormy';

type _TransformValues<Values> = (values: Values) => unknown;

type UseFormInternalParam = { id?: string } | undefined;

const useForm_ = <
  Values extends Record<string, any> = Record<string, any>,
  TransformValues extends _TransformValues<Values> = (values: Values) => Values,
>(
  arg0: UseFormInput<Values, TransformValues>,
  ...args: UseFormInternalParam[]
): UseFormReturnType<Values, TransformValues> & {
  formRef?: React.RefObject<HTMLDivElement>;
} => {
  const form_ = useForm<Values, TransformValues>(arg0);
  const { formRef } = useFormy({ id: args[0]?.id, form: form_ });
  return { ...form_, formRef };
};

export { useForm_ as useForm };
